// extracted by mini-css-extract-plugin
module.exports = {"page":"page___2bYH-","resultPanel":"resultPanel___2VSYt","icon":"icon___1LNm_","successIcon":"successIcon___3CSoj","failIcon":"failIcon___HzutB","resultText":"resultText___2dlj2"};